import { useContext, useLayoutEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { ClosePopup, DropdownInfo, ErrorPopup, FirstContactSuc, LangSelection, LinkSmart, LoadButton, SquareButton } from "../common/Common";
import { LocaleContext, LoginContext, ScrollContext, StateContext } from "../common/App";
import "./WebsiteCommon.css"
import { LoadState, MediationStatus } from "../common/enums.mjs";
import { logoutConsumer, sanitizeStr } from "../common/util";
import { ConsumerContext } from "..";
import { useNavigateSmart } from "../common/hooks";

export function Footer(props) {
    const locale = useContext(LocaleContext);
    const consumer = useContext(ConsumerContext);
    const login = useContext(LoginContext);
    const state = useContext(StateContext);
    const scroll = useContext(ScrollContext);

    const navigate = useNavigateSmart();

    const [logoutState, setLogoutState] = useState(LoadState.NONE);

    const logoutOptionRef = useRef();


    // FUNCTIONS:

    function handleLogoutClick() {
        try {
            logoutConsumer(state, login, consumer).then(() => {
                setLogoutState(LoadState.LOAD_SUCCESS);
                navigate("/");
                scroll.scrollToPlain(0, 0);
            }).catch((error) => {
                console.log(error);
                setLogoutState(LoadState.LOAD_ERROR);
            });

            // Calling setLogoutState() after logoutConsumer() as it could throw an exception
            setLogoutState(LoadState.LOADING);
		}
		catch(e) {
			console.log(e);
		}
    }

    function handleNewsletterClick() {
        if(consumer.newsletter) {
            consumer.setNewsletterSubscribedPopupDisplayed("already subscribed");
        }
        else {
            consumer.setNewsletterPopupDisplayed(true);
        }
    }


    // RENDER:

    return(
        <div id="footer">
            <div className="footer_lang_selection">
                <LangSelection noMargin={true} />
            </div>

            <div className="text_big_bold footer_head_first">{locale.msgs.MANNY_NANNY}</div>
            <LinkSmart onClick={() => scroll.scrollToPlain(0, 0)} className="text_small_small footer_href first_footer_href" to="/">{locale.msgs.STARTPAGE}</LinkSmart>
            <LinkSmart onClick={() => scroll.scrollToPlain(0, 0)} className="text_small_small footer_href" to="/families/">{locale.msgs.FOR_FAMILIES}</LinkSmart>
            <LinkSmart onClick={() => scroll.scrollToPlain(0, 0)} className="text_small_small footer_href" to="/m_n/">{locale.msgs.FOR_M_N}</LinkSmart>
            <LinkSmart onClick={() => scroll.scrollToPlain(0, 0)} className="text_small_small footer_href" to="/how_it_works/">{locale.msgs.HOW_BROKERAGE_WORKS}</LinkSmart>
            <LinkSmart onClick={() => scroll.scrollToPlain(0, 0)} className="text_small_small footer_href" to="/about_us/">{locale.msgs.ABOUT_US}</LinkSmart>
            <LinkSmart onClick={() => scroll.scrollToPlain(0, 0)} className="text_small_small footer_href" to="/blog/">{locale.msgs.BLOG_POSTS}</LinkSmart>

            {/*
            <LinkSmart onClick={() => scroll.scrollToPlain(0, 0)} className="text_small_small footer_href" to="/academy">{locale.msgs.ACADEMY}</LinkSmart>
            <LinkSmart onClick={() => scroll.scrollToPlain(0, 0)} className="text_small_small footer_href" to="/login/">{locale.msgs.COMPANY_EVENTS}</LinkSmart>
            <LinkSmart onClick={() => scroll.scrollToPlain(0, 0)} className="text_small_small footer_href" to="/login/">{locale.msgs.FRANCHISE}</LinkSmart>
            */}

            <LinkSmart onClick={() => scroll.scrollToPlain(0, 0)} className="text_small_small footer_href" to="/diversity/">{locale.msgs.DIVERSITY}</LinkSmart>
            <LinkSmart onClick={() => scroll.scrollToPlain(0, 0)} className="text_small_small footer_href" to="/contact">{locale.msgs.CONTACT}</LinkSmart>

            <div onClick={handleNewsletterClick} className="text_small_small footer_href">{locale.msgs.NEWSLETTER}</div>

            <LinkSmart onClick={() => scroll.scrollToPlain(0, 0)} className="text_small_small footer_href" to="/locations/">{locale.msgs.LOCATION_PAGES}</LinkSmart>
            <LinkSmart onClick={() => scroll.scrollToPlain(0, 0)} className="text_small_small footer_href" to="/faq/">{locale.msgs.FAQ}</LinkSmart>

            { login.loggedIn ?
                !login.mailConfirmed ?
                    null
                :
                    consumer.mediationStatus === MediationStatus.NONE ?
                        <LinkSmart onClick={() => scroll.scrollToPlain(0, 0)} className="text_small_small footer_href" to="/collect_data/how_it_works/">{locale.msgs.DATA_COLLECTION}</LinkSmart>
                    :
                        <LinkSmart onClick={() => scroll.scrollToPlain(0, 0)} className="text_small_small footer_href" to="/dashboard/">{locale.msgs.DASHBOARD_CONSUMER}</LinkSmart>
            :
                null
            }

            { login.loggedIn ?
                <div ref={logoutOptionRef} className="footer_logout_box">
                    <div onClick={() => {
                                handleLogoutClick();
                            }}
                            className="footer_logout_link text_small_small">{locale.msgs.LOGOUT}</div>

                    {logoutState === LoadState.LOADING ?
                            <div className="loader menu_option_loader"></div>
                        :
                            null
                    }
                </div>
            :
                null
            }

            <div className="text_big_bold footer_head">{locale.msgs.LEGAL_MATTERS}</div>
            <div className="text_small_small footer_href first_footer_href"
                    onClick={() => {
                        consumer.setShowCookies(true);
                        // scroll.scrollToPlain(0, 0);
                    }}>
                {locale.msgs.COOKIE_SETTINGS}
            </div>

            <LinkSmart onClick={() => scroll.scrollToPlain(0, 0)} className="text_small_small footer_href" to="/privacy_policy/">{locale.msgs.PRIVACY_POLICY}</LinkSmart>
            <LinkSmart onClick={() => scroll.scrollToPlain(0, 0)} className="text_small_small footer_href" to="/terms_of_use/">{locale.msgs.TOS}</LinkSmart>
            <LinkSmart onClick={() => scroll.scrollToPlain(0, 0)} className="text_small_small footer_href" to="/imprint/">{locale.msgs.IMPRINT}</LinkSmart>

            <div className="text_big_bold footer_head">{locale.msgs.SOCIAL_MEDIA}</div>
            <div id="social_media_box">
                <img className="social_media_icon" src="/customer/icons/icon_instagram.svg" onClick={ (e) => consumer.setForwardArr(["Instagram", "https://www.instagram.com/manny.nanny.babysitter.agentur/?igsh=MXNmYTRrbm9pdjhleg%3D%3D"]) }></img>
                <img className="social_media_icon" src="/customer/icons/icon_facebook.svg" onClick={ (e) => consumer.setForwardArr(["Facebook", "https://www.facebook.com/profile.php?id=61569140956471"]) }></img>
                {/* <img className="social_media_icon" src="/customer/icons/icon_tiktok.svg" onClick={ (e) => navigate("/") }></img> */}
                <img className="social_media_icon" src="/customer/icons/icon_linkedin.svg" onClick={ (e) => consumer.setForwardArr(["LinkedIn", "https://www.linkedin.com/company/die-babysitteragentur-manny-nanny/"]) }></img>
            </div>

            <ErrorPopup helpDisplayed={logoutState === LoadState.LOAD_ERROR} btnRef={logoutOptionRef} onClose={() => setLogoutState(LoadState.NONE)} />
        </div>
    );
}

export function ForFamiliesSteps(props) {
    const locale = useContext(LocaleContext);
    const consumer = useContext(ConsumerContext);

    const navigate = useNavigateSmart();

    const [sucArr, setSucArr] = useState(Array(8).fill(false));
    const [openArr, setOpenArr] = useState(Array(8).fill(false));

    const [dropdownRecalcTrigger, setDropdownRecalcTrigger] = useState(false);

    let theme = "bright";
    let dashboard = false;

    if(props.mode === "dashboard") {
        theme = "dark";
        dashboard = true;
    }

    useLayoutEffect(() => {
        if(props.mediationStatus == MediationStatus.APPLICATION_INTERESTING) {
            setSucArr([true, false, false, false, false, false, false, false]);
            setOpenArr([true, false, false, false, false, false, false, false]);
        }
        else if(props.mediationStatus == MediationStatus.ONLINE_MEETING) {
            setSucArr([true, true, false, false, false, false, false, false]);
            setOpenArr([false, true, false, false, false, false, false, false]);
        }
        else if(props.mediationStatus == MediationStatus.PROTECTION_FEE || props.mediationStatus == MediationStatus.VOTING) {
            setSucArr([true, true, true, false, false, false, false, false]);
            setOpenArr([false, false, true, false, false, false, false, false]);
        }
        else if(props.mediationStatus == MediationStatus.PROTECTION_FEE_INVOICE_AVAILABLE) {
            setSucArr([true, true, true, true, false, false, false, false]);
            setOpenArr([false, false, false, true, false, false, false, false]);
        }
        else if(props.mediationStatus == MediationStatus.FIND_MATCH) {
            setSucArr([true, true, true, true, false, false, false, false]);
            setOpenArr([false, false, false, true, false, false, false, false]);
        }
        else if(props.mediationStatus == MediationStatus.MATCH_FOUND) {
            setSucArr([true, true, true, true, true, false, false, false]);
            setOpenArr([false, false, false, false, true, false, false, false]);
        }
        else if(props.mediationStatus == MediationStatus.FINAL_CONFIRMATION) {
            setSucArr([true, true, true, true, true, true, false, false]);
            setOpenArr([false, false, false, false, false, true, false, false]);
        }
        else if(props.mediationStatus == MediationStatus.MEDIATION_FEE || props.mediationStatus == MediationStatus.MEDIATION_FEE_INVOICE_AVAILABLE) {
            setSucArr([true, true, true, true, true, true, true, false]);
            setOpenArr([false, false, false, false, false, false, true, false]);
        }
        else if(props.mediationStatus == MediationStatus.MEDIATION_DONE) {
            setSucArr([true, true, true, true, true, true, true, true]);
            setOpenArr([false, false, false, false, false, false, false, true]);
        }
    }, [props.mediationStatus]);

    return (
        <div>
            <DropdownInfo number="1" theme={theme} success={sucArr[0]} open={openArr[0]}
                    name={locale.msgs.STEP_1_FAMILY_TITLE_WEBSITE}
                    content={<div className="noselect" dangerouslySetInnerHTML={{__html: locale.msgs.STEP_1_FAMILY_DESCR_WEBSITE}}></div>}
                    successContent={<div className="noselect" dangerouslySetInnerHTML={{__html: locale.msgs.STEP_1_FAMILY_DESCR_DASHBOARD_DONE }}></div>}
            />

            <DropdownInfo number="2" theme={theme} success={sucArr[1]} open={openArr[1]} recalcTrigger={dropdownRecalcTrigger}
                    name={ dashboard ? locale.msgs.STEP_2_FAMILY_TITLE_DASHBOARD : locale.msgs.STEP_2_FAMILY_TITLE_WEBSITE }
                    content={<div className="noselect" dangerouslySetInnerHTML={{__html: (dashboard ? locale.msgs.STEP_2_FAMILY_DESCR_DASHBOARD : locale.msgs.STEP_2_FAMILY_DESCR_WEBSITE) }}></div>}
                    successContent={
                        <FirstContactSuc descr={locale.msgs.STEP_2_FAMILY_DESCR_DASHBOARD_DONE} onLoad={() => setDropdownRecalcTrigger(!dropdownRecalcTrigger)} />
                    }
            />

            <DropdownInfo number="3" theme={theme} success={sucArr[2]} open={openArr[2]}
                    name={ dashboard ? locale.msgs.STEP_3_FAMILY_TITLE_DASHBOARD : locale.msgs.STEP_3_FAMILY_TITLE_WEBSITE }
                    content={<div className="noselect" dangerouslySetInnerHTML={{__html: (dashboard ? locale.msgs.STEP_3_FAMILY_DESCR_DASHBOARD : locale.msgs.STEP_3_FAMILY_DESCR_WEBSITE) }}></div>}
                    successContent={<div className="noselect" dangerouslySetInnerHTML={{__html: locale.msgs.STEP_3_FAMILY_DESCR_DASHBOARD_DONE }}></div>}
            />

            { dashboard ?
                <DropdownInfo number="4" theme={theme} success={sucArr[3]} open={openArr[3]}
                        name={locale.msgs.STEP_4_FAMILY_TITLE_DASHBOARD}
                        content={<div className="noselect" dangerouslySetInnerHTML={{__html: locale.msgs.STEP_4_FAMILY_DESCR_DASHBOARD}}></div>}
                        successContent={
                            props.mediationStatus === MediationStatus.PROTECTION_FEE_INVOICE_AVAILABLE ?
                                <div className="first_info_suc_box">
                                    <div className="noselect" dangerouslySetInnerHTML={{__html: locale.msgs.STEP_4_FAMILY_DESCR_DASHBOARD_DONE}}></div>

                                    <div className="first_info_suc_btn">
                                        <SquareButton text={locale.msgs.MY_PROFILE} clickable={true} onClick={() => navigate("profile/?tab=invoices")} />
                                    </div>
                                </div>
                            :
                                <div className="first_info_suc_box">
                                    <div className="noselect" dangerouslySetInnerHTML={{__html: consumer.protectionFeeSkipped ? locale.msgs.STEP_4_FAMILY_DESCR_DASHBOARD_DONE_2_SKIPPED : locale.msgs.STEP_4_FAMILY_DESCR_DASHBOARD_DONE_2}}></div>
                                </div>
                        }
                />
            :
                null
            }

            <DropdownInfo number={ dashboard ? "5" : "4" } theme={theme} success={sucArr[4]} open={openArr[4]}
                    name={ dashboard ? locale.msgs.STEP_5_FAMILY_TITLE_DASHBOARD : locale.msgs.STEP_5_FAMILY_TITLE_WEBSITE }
                    content={<div className="noselect" dangerouslySetInnerHTML={{__html: (dashboard ? locale.msgs.STEP_5_FAMILY_DESCR_DASHBOARD : locale.msgs.STEP_5_FAMILY_DESCR_WEBSITE) }}></div>}
                    successContent={
                        <div className="first_info_suc_box">
                            <div className="noselect" dangerouslySetInnerHTML={{__html: locale.msgs.STEP_5_FAMILY_DESCR_DASHBOARD_DONE}}></div>
                            <div className="first_info_suc_btn">
                                <SquareButton text={locale.msgs.MY_MATCH} clickable={true} onClick={() => navigate("match/")} />
                            </div>
                        </div>
                    }
            />

            <DropdownInfo number={ dashboard ? "6" : "5" } theme={theme} success={sucArr[5]} open={openArr[5]}
                    name={ dashboard ? locale.msgs.STEP_6_FAMILY_TITLE_DASHBOARD : locale.msgs.STEP_6_FAMILY_TITLE_WEBSITE }
                    content={<div className="noselect" dangerouslySetInnerHTML={{__html: (dashboard ? locale.msgs.STEP_6_FAMILY_DESCR_DASHBOARD : locale.msgs.STEP_6_FAMILY_DESCR_WEBSITE) }}></div>}
                    successContent={
                        <div className="first_info_suc_box">
                            <div className="noselect" dangerouslySetInnerHTML={{__html: locale.msgs.STEP_6_FAMILY_DESCR_DASHBOARD_DONE}}></div>
                            <div className="first_info_suc_btn">
                                <SquareButton text={locale.msgs.MY_MATCH} clickable={true} onClick={() => navigate("match/")} />
                            </div>
                        </div>
                    }
            />

            { dashboard ?
                <DropdownInfo number="7" theme={theme} success={sucArr[6]} open={openArr[6]}
                        name={locale.msgs.STEP_7_FAMILY_TITLE_DASHBOARD}
                        content={<div className="noselect" dangerouslySetInnerHTML={{__html: locale.msgs.STEP_7_FAMILY_DESCR_DASHBOARD }}></div>}
                        successContent={
                            props.mediationStatus === MediationStatus.MEDIATION_FEE ?
                                <div className="first_info_suc_box">
                                    <div className="noselect" dangerouslySetInnerHTML={{__html: locale.msgs.STEP_7_FAMILY_DESCR_DASHBOARD_DONE}}></div>
                                </div>
                            : props.mediationStatus === MediationStatus.MEDIATION_FEE_INVOICE_AVAILABLE ?
                                <div className="first_info_suc_box">
                                    <div className="noselect" dangerouslySetInnerHTML={{__html: locale.msgs.STEP_7_FAMILY_DESCR_DASHBOARD_DONE_2}}></div>

                                    <div className="first_info_suc_btn">
                                        <SquareButton text={locale.msgs.MY_PROFILE} clickable={true} onClick={() => navigate("profile/?tab=invoices")} />
                                    </div>
                                </div>
                            :
                                null
                        }
                />
            :
                null
            }

            <DropdownInfo number={ dashboard ? "8" : "6" } theme={theme} success={sucArr[7]} open={openArr[7]}
                    name={ dashboard ? locale.msgs.STEP_8_FAMILY_TITLE_DASHBOARD : locale.msgs.STEP_8_FAMILY_TITLE_WEBSITE }
                    content={<div className="noselect" dangerouslySetInnerHTML={{__html: (dashboard ? locale.msgs.STEP_8_FAMILY_DESCR_DASHBOARD : locale.msgs.STEP_8_FAMILY_DESCR_WEBSITE) }}></div>}
                    successContent={<div className="noselect" dangerouslySetInnerHTML={{__html: consumer.mediationFeeSkipped ? locale.msgs.STEP_8_FAMILY_DESCR_DASHBOARD_DONE_SKIPPED : locale.msgs.STEP_8_FAMILY_DESCR_DASHBOARD_DONE }}></div>}
            />
        </div>
    )
}

export const PricingText = ({}) => {
    const locale = useContext(LocaleContext);

    return (
        <div className="text">
            <span dangerouslySetInnerHTML={{__html: locale.msgs.AMOUNT_OF_FEES_DESCR}}/>
            <LinkSmart className="text_2 link_2" to={"/faq/?question=14&question=15"}>{locale.msgs.EXACT_PRICING_OVERVIEW}</LinkSmart>
        </div>
    );
}

export const FaqQuestion = ({question, answer, rawAnswer, open, noScrollOnOpen, scrollTopHeightEle}) => {

    return(
        <DropdownInfo success={false} open={open ? true : false} noScrollOnOpen={noScrollOnOpen} scrollTopHeightEle={scrollTopHeightEle}
                minimal={false} noCircle={true} noMargin={true} scrollToTop={true}
                /*recalcTrigger={dropdownRecalcTrigger}*/
                /*name={ <div style={{fontWeight: 600}}>{locale.msgs.INFORMATION}</div>} */
                name={
                    <div className="faq_question_name">
                        <img src="/customer/icons/icon_faq.svg" />
                        <div className="faq_question_text" dangerouslySetInnerHTML={{__html: sanitizeStr(question)}}></div>
                    </div>
                }
                content={
                    !rawAnswer ?
                        (<div className="faq_answer" dangerouslySetInnerHTML={{__html: sanitizeStr(answer)}}
                                onClick={(e) => e.stopPropagation()} ></div>)
                    : rawAnswer
                }
        />
    );
}
